import "./topNav.css";

import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Drawer, IconButton } from "@mui/material";
import { Menu as MenuIcon, Close as CloseIcon } from "@mui/icons-material";

import { PAGE_ROUTES, HOME_SECTIONS, CONTACT_DETAILS } from "../../utils/stateTypes";
import { useScrolledPast } from "../general/hooks";
import SocialLinks from "../general/SocialLinks";

const NAV_ITEMS = [
  {
    label: "Home",
    to: PAGE_ROUTES.HOME,
    activePath: PAGE_ROUTES.HOME,
  },
  {
    label: "About",
    to: HOME_SECTIONS.ABOUT,
  },
  {
    label: "Services",
    to: PAGE_ROUTES.SERVICES,
    activePath: PAGE_ROUTES.SERVICES,
  },
  {
    label: "Contact",
    to: HOME_SECTIONS.CONTACT,
  },
];

const TopNav = () => {
  const { pathname } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const isScrolled = useScrolledPast(40);

  //Close the mobile menu on navigation
  React.useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  const renderLinks = (onClick = null) => NAV_ITEMS.map((item) => (
    <Link
      key={item.label}
      to={item.to}
      onClick={onClick}
      className={(item.activePath === pathname) ? "active" : ""}
      aria-current={(item.activePath === pathname) ? "page" : undefined}
    >
      {item.label}
    </Link>
  ));

  return (
    <header className={`top-nav ${isScrolled ? "scrolled" : ""}`}>
      <div className={"top-nav-inner"}>
        <Link
          to={PAGE_ROUTES.HOME}
          className={"top-nav-logo"}
          aria-label={"Janine Botha Attorneys Inc. - home"}
        >
          <img
            src={"/images/logo-header.png"}
            alt={"Janine Botha Attorneys Inc. - Attorney, Notary & Conveyancer"}
            width={312}
            height={125}
          />
        </Link>

        <nav
          className={"top-nav-links"}
          aria-label={"Main"}
        >
          {renderLinks()}
        </nav>

        <SocialLinks className={"top-nav-social"} />

        <IconButton
          className={"top-nav-burger"}
          onClick={() => setIsMenuOpen(true)}
          aria-label={"Open menu"}
        >
          <MenuIcon />
        </IconButton>
      </div>

      <Drawer
        anchor={"right"}
        open={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        PaperProps={{ className: "mobile-menu" }}
      >
        <IconButton
          className={"mobile-menu-close"}
          onClick={() => setIsMenuOpen(false)}
          aria-label={"Close menu"}
        >
          <CloseIcon />
        </IconButton>
        <nav
          className={"mobile-menu-links"}
          aria-label={"Main"}
        >
          {renderLinks(() => setIsMenuOpen(false))}
        </nav>
        <div className={"mobile-menu-contact"}>
          <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>
          <a href={CONTACT_DETAILS.PHONE_LINK}>{CONTACT_DETAILS.PHONE}</a>
          <SocialLinks />
        </div>
      </Drawer>
    </header>
  );
};

export default TopNav;
